// Core imports
import React, { Fragment, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

// Component imports
import { Card, Col, Row } from 'antd';
import MissedQuestionsTotalSection from './MissedQuestionsTotalSection';
import MissedQuestionsTopHundredSection from './MissedQuestionsTopHundredSection';
import MissedQuestionsTotalPerDaySection from './MissedQuestionsTotalPerDaySection';

// Misc imports
import { ANALYTICS_SECTIONS } from '../../constants/main';
import { useFetchMissedQuestionsAnalyticsQuery } from '../../store/analytics/analyticsApi';
import { isEmptyArray } from '../../utils/is/isEmptyArray';

const AnalyticsMissedQuestionsTab = ({
  requestParams,
  setIsLoading = () => false,
  isPublicMode
}) => {

  const { data: missedQuestionsAnalytics, isFetching: isFetchingMissedQuestionsAnalytics, isUninitialized } = useFetchMissedQuestionsAnalyticsQuery({ ...requestParams?.[0] }, { skip: isEmptyArray(requestParams) });

  // Memoize loading state to prevent unnecessary re-renders
  const isLoading = useMemo(() =>
    isFetchingMissedQuestionsAnalytics || isUninitialized,
  [isFetchingMissedQuestionsAnalytics, isUninitialized]
  );

  useEffect(() => {
    setIsLoading(isLoading);

    return (() => {
      setIsLoading(false);
    });
  }, [isLoading]);

  const renderMissedQuestionsSection = () => {
    return (
      <Row gutter={[16, 16]} className="mb-5 hide-empty" id={`analytics-section_${ANALYTICS_SECTIONS.MISSED_QUESTIONS.key}`}>
        <Col xs={24} md={12} xxl={8} id={`analytics-section_${ANALYTICS_SECTIONS.MISSED_QUESTIONS.key}_${ANALYTICS_SECTIONS.MISSED_QUESTIONS.subSections.TOTAL_MISSED_QUESTIONS.key}`}>
          <Card className="h-100">
            <MissedQuestionsTotalSection
              data={missedQuestionsAnalytics}
              sectionTitle={t('Total Missed Questions')}
              isLoading={isLoading}
            />
          </Card>
        </Col>

        <Col xs={24} md={12} xxl={8} id={`analytics-section_${ANALYTICS_SECTIONS.MISSED_QUESTIONS.key}_${ANALYTICS_SECTIONS.MISSED_QUESTIONS.subSections.TOP_100_MISSED_QUESTIONS.key}`}>
          <Card className="h-100">
            <MissedQuestionsTopHundredSection
              data={missedQuestionsAnalytics?.missedQuestions}
              sectionTitle={t('Top 100 Missed Questions')}
              isLoading={isLoading}
            />
          </Card>
        </Col>

        <Col xs={24} md={12} xxl={8} id={`analytics-section_${ANALYTICS_SECTIONS.MISSED_QUESTIONS.key}_${ANALYTICS_SECTIONS.MISSED_QUESTIONS.subSections.TOTAL_MISSED_QUESTIONS_PER_DAY.key}`}>
          <Card className="h-100">
            <MissedQuestionsTotalPerDaySection
              data={missedQuestionsAnalytics}
              isLoading={isLoading}
              sectionTitle={t('Total Missed Questions Per Day')}
            />
          </Card>
        </Col>
      </Row>
    );
  };

  return (
    <Fragment>
      {renderMissedQuestionsSection()}
    </Fragment>
  );
};

AnalyticsMissedQuestionsTab.propTypes = {
  requestParams: PropTypes.array,
  setIsLoading: PropTypes.func,
  isPublicMode: PropTypes.bool
};

export default AnalyticsMissedQuestionsTab;
